import React, { Component } from 'react';
import axios from "axios";
import OtpInput from 'react-otp-input';
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
import Waiting from './../../../waiting';
import { appConfig } from '../../../../tools/AppConfig';
import blnkLogo from "./../../../../../statics/img/blnk/blnk.png";
import paymobLogo from "./../../../../../statics/img/blnk/paymob.png";
import Status from '../../components/IframeStatus/Status';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import jwt_decode from "jwt-decode";
import './Blnk.css';

const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
    }
};
const phoneV = (value) => {
    if(!validator.isNumeric(value) || value.length != 11 || value.toString()[0] != 0){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter a valid phone number.</div>;
    }
};

let resend_setInterval; 
class Blnk extends Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            phone: "",
            user_data: "",
            trnx_id: "",
            re_inquire_times: 0,
            //public
            waiting: false,
            error: false,
            error_message: "",
            submit_step_3:false,
            installmentPlanId:"",
            selected_plan_index:0,
            // Status Screen
            status: null,
            status_message: "",
            redirection_url: "",

        }
    }
    componentDidMount() {
        this.decodePaymentToken()
    }
    
    // decode payment token
    decodePaymentToken = () => {
        // decode from base64 format
        let base64 = base64_decode(this.props.payment_token);
        // decode from jwt format
        let jwt = jwt_decode(base64);
        this.setState({user_data: jwt});
    }
    // installments request
    handleGetInstallments = (e) =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/blnk/installment_plans';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "customer_number": this.state.phone,
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({...resp.data, installmentPlanId:resp.data.installment_plans.loan_products[0]['loan_product_id'], waiting: false, step: 2,error_message: ""});
            })
            .catch((err)=>{
                if(err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});

                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
        e.preventDefault();
    }
    handlePay = (e) =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source": {
                    "identifier": this.state.phone,
                    "subtype": "BLNK",
                    "purchase_id": this.state.installmentPlanId,
                },
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({...resp.data, waiting: false, step:3});
                this.sendOtp();
            })
            .catch((err)=>{
                if(err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});

                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
        e.preventDefault();
    }
 
    //handleSendOtp
    sendOtp = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/blnk/send_otp';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "payment_token": this.props.payment_token,
                "transaction":this.state.id,
                "loan_product_id":this.state.installmentPlanId,
                "product_name": this.state.data.product_name


            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: ""}, () => {
                    this.start_resend_counter();
                });
            })
            .catch((err)=>{
                if(err.response.data && err.response.data.message){
                    this.setState({waiting: false, error: true, error_message: err.response.data.message});
                }else{
                    this.setState({waiting: false, public_error: true, public_error_message: "Something went wrong."});
                }
            });
        });
    }
    confirmTrnx = () => {
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/blnk/confirm_otp';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "transaction": this.state.id,
                "otp": this.state.otp,
                "payment_token": this.props.payment_token,
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                if(resp.data.success === true && resp.data.pending === false){
                    // success
                    if(resp.data.redirection_url){
                        this.setState({waiting: false, error: false, error_message: "", status: "success", redirection_url: resp.data.redirection_url});
                    }
                    else{
                        this.setState({waiting: false, error: false, error_message: "", status: "success", redirection_url: resp.data.redirection_url});
                    }
                }else if(resp.data.success === false && resp.data.pending === true){
                    // pending
                    this.setState({waiting: false, error: false,submit_step_3: false, error_message: "", status: "pending", redirection_url: resp.data.redirection_url});
                }else if(resp.data.success === false && resp.data.pending === false){
                    // fail
                    this.setState({waiting: false, error: false, submit_step_3: false, error_message: "", status: "fail", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }
                else{
                    this.setState({waiting: false, error: false, submit_step_3: false, error_message: "", redirection_url: resp.data.redirection_url, status_message: resp.data["data.message"]});
                }
            })
            .catch((err)=>{
                // Max Trials for Invalid OTP
                if(this.state.invalid_otp_times !== 3){
                    if(err.response.data && err.response.data.data.message){
                        this.setState({waiting:false, submit_step_3:false, error: true, error_message: err.response.data.data.message, otp: ""});
                    }else{
                        this.setState({waiting:false, submit_step_3:false, error: true, error_message: "Something went wrong please try again.",otp: ""});
                    }
                }else{
                    this.cancelTrnx();
                }
                // Increase Trials for Invalid OTP
                this.setState({invalid_otp_times: this.state.invalid_otp_times + 1});
            }); 
        });
    }
        // OTP Validation
        handle_otp_change = (value) => {
            this.setState({otp: value, error: false, error_message: ""}, () => {
                if(this.state.otp === ""){
                    this.setState({otp_error: true, otp_error_message: "This field is required.", submit_step_4: false});
                }else if(this.state.otp.length !== 5){
                    this.setState({otp_error: true, otp_error_message: "Please Enter a valid OTP", submit_step_4: false});
                }else{
                    this.setState({otp_error: false, otp_error_message: "", submit_step_4: true});
                } 
            });
        }
        // handle Resend OTP
        handleResendOtp = () => {
            this.setState({resend_otp_times: this.state.resend_otp_times + 1}, () => {
                if(this.state.resend_otp_times === 4){
                    this.cancelTrnx();
                }else{
                    this.sendOtp();
                }
            });
        }
            // Handle select plan
    handle_select_plan = (plan, index) => {
        let new_state = {...this.state}
        new_state.selected_plan = plan;
        new_state.selected_plan_index = index;
        new_state.admin_fees = plan.adminFees;
        new_state.installmentPlanId = plan.loan_product_id;
        new_state.selected_plan_index = index;
        this.setState({...new_state});
    }
        // Resend OTP Counter 
        start_resend_counter = () => {
            this.setState({resend: true});
            clearInterval(resend_setInterval);
            resend_setInterval = setInterval(()=>this.resend_counter_calc(), 1000)
        }
        resend_counter_calc = () => {
            if(this.state.resend_counter > 0){
                this.setState({resend_counter: this.state.resend_counter - 1});
            }else{
                clearInterval(resend_setInterval);
                this.setState({resend_counter: 30, resend: false});
            }
        }
    // handle return back
    handleReturnBack = () => {
        this.setState({blnk_status: "fail", status_message: "Transaction abandoned."});
    }
    renderStep1 = () => (
        <div className="blnk_content blnk_home_content blnk_phone_number_input">
            <VForm onSubmit={this.handleGetInstallments}>
                <label>Customer Phone Number</label><br/>
               <span className="blnk_country_code">+2</span><VInput 
                    type="text"
                    name="phone"
                    value={this.state.phone}
                    onChange={(e)=>this.setState({phone: e.target.value})}
                    validations={[required, phoneV]} 
                />
                <VButton>Proceed</VButton>
            </VForm>
            {this.state.error &&
                <div className="blnk_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )
    renderStep2 = () => (
        <div className="blnk_content  text-center iframe_content">
        <VForm onSubmit={this.handlePay}>
            <div style={{marginTop:"40px"}}>
                <p className="blnk_header_content">Customer Name: <span>{this.state.first_name +" "+ this.state.last_name}</span></p>
                <hr className="full"/>
                <p className="blnk_header_content">Available Limit: <span>{this.state.user_data.currency} {this.state.remaining_limit}</span></p>
                <hr className="full"/>
                <div class="installment installment_plans_container">
                    <p className="blnk_header_content">Installment Plan</p>
                    {this.state.change_installment_waiting ?
                    <Waiting height='200px' />
                :
                    <div className="installment_plans">
                        {this.state.installment_plans && this.state.installment_plans.loan_products.map((plan, index) => (
                            <div key={index} onClick={()=>this.handle_select_plan(plan, index)} className={`${this.state.selected_plan_index === index ? "selected" : ""}`}>
                                <label>
                                    <span className="circle"><span></span></span>
                                    <p>{plan.tenor} Months</p>
                                    <span>{this.state.user_data.currency} {plan.installment} Monthly</span><br/>
                                    <span>{this.state.user_data.currency} {plan.admin_fee} Admin Fees</span>
                                </label>
                            </div>
                        ))}
                    </div>
                }
                </div>
            </div>
            {this.state.error &&
                <div className="blnk_error">
                    {this.state.error_message}
                </div>
            }
                <VButton>Next</VButton>
            </VForm>
        </div>
    )
     getTenor = ()=>{
        const selectedInstallmentPlan = this.state.installment_plans.loan_products.filter((plan)=>plan.loan_product_id == this.state.installmentPlanId)
        return selectedInstallmentPlan[0].tenor;
    }
    handle_otp_change = (value) => {
        this.setState({otp: value, error: false, error_message: ""}, () => {
            if(this.state.otp === ""){
                this.setState({otp_error: true, otp_error_message: "This field is required.", submit_step_3: false});
            }else if(this.state.otp.length !== 4){
                this.setState({otp_error: true, otp_error_message: "Please Enter a valid OTP", submit_step_3: false});
            }else{
                this.setState({otp_error: false, otp_error_message: "", submit_step_3: true});
            } 
        });
    }
    renderStep3 = () => (
        <div className="blnk_content  text-center">
        <VForm onSubmit={this.confirmTrnx}>
        <div className="">
            <h3 className="verification">Summary and verification</h3>
            <p>Please enter the 4-digit code sent to <br/>{this.state.phone}</p>
            <OtpInput 
                numInputs={4} 
                value={this.state.otp}
                onChange={(value) => this.handle_otp_change(value)} 
                isInputNum
                containerStyle="BlnkOtpInput"
                placeholder="••••••"
                required
            />
            {this.state.otp_error &&
                <div className="alert alert-danger" id="otp_error">
                    {this.state.otp_error_message}
                </div>
            }
            <div className="resend_otp">
                <p>
                    Didn’t receive code?
                    {this.state.resend?
                        <span>Send again in<span>{this.state.resend_counter}</span> sec.</span>
                    :
                        <span className="send_again" onClick={()=>this.handleResendOtp()}>Send again</span>
                    }
                </p>
            </div>
            {this.state.error &&
                <div className="iframe_error">
                    {this.state.error_message}
                </div>
            }
        </div>
            <div className="summary">
                <p>Transaction Id: <span>{this.state.id}</span></p>
                <hr className="full"/>
                <p>Customer Name: <span>{this.state.data.customer_name}</span></p>
                <hr className="full"/>
                <p>Phone Number<span>{this.state.phone}</span></p>
                <hr className="full"/>
                <p>Merchant Name: <span>{this.state.data.merchant_name}</span></p>
                <hr className="full"/>
                <p>Tenor: <span>{this.getTenor()}</span> Months</p>
             
            </div>
            {this.state.error &&
                <div className="blnk_error">
                    {this.state.error_message}
                </div>
            }
                <button type="submit" disabled={!this.state.submit_step_3}>Pay</button>
            </VForm>
        </div>
    )

    render() {
        return (
            <div className="page_container">
                {this.state.status == null ?
                    <div className="blnk_container">
                        {this.state.step == 1 && <span onClick={()=>this.handleReturnBack()}>X <span>Cancel</span></span>}
                        <div className="blnk_header">
                            <img src={blnkLogo} />
                        </div>
                        {this.state.waiting ?
                            <Waiting height='400px' />
                        :
                            this.state.step == 1 ?
                                this.renderStep1()
                            :
                                this.state.step== 2 ?this.renderStep2()
                                :this.renderStep3()

                        }
                        <div className="blnk_footer">
                            <span>Powered by</span>
                            <img src={paymobLogo} className="paymob" alt="Paymob" />
                        </div>
                    </div>
                :
                    <div className="blnk_container">
                                <Status
                                    status={this.state.status}
                                    status_message={this.state.status_message}
                                    gateway_name="BLNK"
                                    redirection_url={this.state.redirection_url}
                                />
                        <div className="blnk_footer">
                            <span>Powered by</span>
                            <img src={paymobLogo} className="paymob" alt="Paymob" />
                        </div>
                    </div>
                }
            </div>
        )
    }
}
export default Blnk;